module.exports = __webpack_public_path__ + "img/31_9.2b5554e5.png";